<template>
	<div class="itemWrapper">
		<div class="userInfor">
			<div class="avatarWrapper">
				<img class="avatarImg img" :src="data.pic" />
			</div>
			<div class="userNameWrapper">
				<div class="userNameText">{{data.author}}</div>
				<div class="decorationText">发布了主题</div>
			</div>
			<div class="time"></div>
		</div>
		<div class="titleWrapper">
			<div class="title">{{data.title}}</div>
		</div>
		<div class="singleContentWrapper" v-if="itemType === 'single' || itemType === 'noImg'">
			<div class="topicContent">{{data.content && data.content.slice(0, 50)}}</div>
			<div class="singleImgWrapper" v-if="itemType === 'single'">
				<img class="img" :src="data.thred_pics[0]" alt="">
			</div>
		</div>
		<div class="multiContentWrapper" v-if="itemType === 'multi'">
			<div class="topicContent">{{data.content && data.content.slice(0, 35)}}</div>
			<div class="multiImgWrapper">
				<div class="multiImgItem" v-for="pic of data.thread_pics" :key="pic">
					<img class="img" :src="pic" alt="">
				</div>
			</div>
		</div>
		<div class="subItems">
			<div class="time">{{data.post_show_time}}</div>
			<div class="rightItems">
				<div class="subitem">
					<span class="icon"><img class="img" src="@/assets/image/personalCenter/eye.png" alt=""></span>
					<span>{{data.views}}</span>
				</div>
				<div class="subitem">
					<span class="icon"><img class="img" src="@/assets/image/personalCenter/comment.png" alt=""></span>
					<span>{{data.replies}}</span>
				</div>
				<div class="subitem">
					<span class="icon"><img class="img" src="@/assets/image/personalCenter/favor.png" alt=""></span>
					<span>{{data.favtimes}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['data'],
	computed: {
		itemType(){
			let pics = this.data.thread_pics || []
			let len = pics.length
			if(len === 1){
				return 'single'
			}else if(len >= 3){
				return 'multi'
			}else{
				return 'noImg'
			}
		}
	}
}
</script>

<style scoped>
.itemWrapper{
	padding: 10px 15px;
	margin-top: 5px;
	background-color: #fff;
}
.userInfor{
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 5px;
}
.avatarWrapper{
	width: 30px;
	height: 30px;
	overflow: hidden;
	border-radius: 15px;
	border-width: 1px;
	border-color: #fff;
}
.avatarImg{
	object-fit: cover;
}
.userNameWrapper{
	flex: 1;
	margin-left: 7px;
	margin-right: 7px;
}
.userNameText{
	font-size: 14px;
	color: #1d2023;
}
.decorationText{
	margin-top: 3px;
	font-size: 11px;
	color: #606972;
}
.titleWrapper{
	margin: 3px 0;
}
.title{
	flex: 1;
	font-size: 18px;
	font-weight: bold;
	color: #000;
}
.singleContentWrapper{
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
}
.topicContent{
	flex:1;
	color: #606972;
	font-size: 16px;
}
.singleImgWrapper{
	width: 112px;
	height: 81px;
	margin-left: 5px;
	flex-shrink: 0;
	border-radius: 6px;
	overflow: hidden;
	background-color: #d8d8d8;
}
.multiContentWrapper{
	margin-bottom: 10px;
}
.multiImgWrapper{
	display: flex;
	flex-wrap: nowrap;
	margin-top: 10px;
}
.multiImgItem{
	width: 30%;
	height: 81px;
	margin-left: 5%;
	flex-shrink: 0;
	border-radius: 6px;
	overflow: hidden;
}
.multiImgItem:first-child{
	margin-left: 0
}

.subItems{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.rightItems{
	display: flex;
}
.subitem{
	display: flex;
	align-items: center;
	padding-left: 4px;
	padding-right: 4px;
	font-size: 12px;
	color: #606972;
}
.time{
	font-size: 12px;
	color: #606972;
}

.icon{
	display: inline-block;
	width: 19px;
	height: 19px;
	margin-right: 3px;
	flex-shrink: 0;
	overflow: hidden;
}
.icon > img{
	object-fit: contain;
}
.hidden{
	display: none;
	width: 0;
	height: 0;
}
.img{
	width: 100%;
	height: 100%;
}
</style>